import React from "react";
import { Link } from "react-router-dom";
import { Segmented } from "antd";
import { SettingFilled } from "@ant-design/icons";
import "./styles.scss";

/**
 * SectionHeader Component - Header for each homepage section (Tag Monitor, DataLayer Guard)
 *
 * @param {string} title - Section title
 * @param {string} color - Dot color: "purple" (Tag Monitor) or "lime" (DataLayer Guard)
 * @param {string} configureLink - Route for the "Configure" link
 * @param {boolean} showToggle - Show the Client-side / Server-side toggle
 * @param {string} toggleValue - Selected toggle value: "client" or "server"
 * @param {function} onToggleChange - Called with the new toggle value
 * @param {boolean} serverDisabled - Disable the Server-side option
 */
const SectionHeader = ({
  title,
  color = "purple",
  configureLink,
  showToggle = false,
  toggleValue = "client",
  onToggleChange,
  serverDisabled = false,
}) => {
  return (
    <div className="section-header">
      <span className={`section-header-dot section-header-dot-${color}`} />
      <h2 className="section-header-title">{title}</h2>
      <span className="section-header-line" />

      {showToggle && (
        <>
          <Segmented
            value={toggleValue}
            onChange={onToggleChange}
            options={[
              { label: "Client-side", value: "client" },
              { label: "Server-side", value: "server", disabled: serverDisabled },
            ]}
          />
          <span className="section-header-line section-header-line-short" />
        </>
      )}

      {configureLink && (
        <Link to={configureLink} className="section-header-configure">
          Configure <SettingFilled />
        </Link>
      )}
    </div>
  );
};

export default SectionHeader;
